import { IPendingSwap } from "@nkr/models/pending-swap";

export interface IActionButtons {
    showPatientOutcomesButton: boolean,
    showAboFileButton: boolean,
    showUploadFinalXmButton: boolean,
    showViewFinalXmButton: boolean,
    showDemographicsFileButton: boolean,
    showHlaFileButton: boolean,
    showRecipientHlaFileButton: boolean,
    showCtReportButton: boolean,
    showMedChartButton: boolean,
    showAboVerifButton: boolean,
    showViewSerologyButton: boolean,
    showAddSerologyButton?: boolean,
    showReuploadSerologyButton: boolean,
    showRequestScreeningXm: boolean,
    hasExistingScreeningXm: boolean,
    showRequestFinalXm: boolean,
    hasExistingFinalXm: boolean,
    canRequestFinalXm: boolean,
    showEmergencyNotification: boolean,
    showRequestSerologyKit: boolean,
    canRequestSerology: boolean,
    showLogisticsPlan?: boolean,
    showFormsAndChecklists?: boolean,
    showDonorCtStudy: boolean,
    showCenterAboVerification: boolean,
    showDonorAboMolecular: boolean,
    swap: IPendingSwap,
    centerId: number
}